// extracted by mini-css-extract-plugin
module.exports = {"titleBox":"styles_titleBox__3fyyG","playAll":"styles_playAll__1vqvc"};